import styled, { css } from "styled-components";
import {
  white,
  blue300,
  black700,
  green300,
  borderLight,
} from "../../../theme/colors";
import themeSizes from "../../../theme/themeSizes";
import { semiBold, bold } from "../../../theme/typeface";
import { microHeading, baseCaption } from "../../../theme/typography";

export const DetailsLayoutWrapper = styled.section`
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  
  @media ${themeSizes.tablet} {
    flex-direction: column;
    margin-top: 16px;
  }
  
  > ul {
    width: 100px;
    margin: 0;
    flex-shrink: 0;
    @media ${themeSizes.tablet} {
      width: 100% !important;
    }
  }
`;

export const VerticalNav = styled.div`
  width: 100%;
  margin-top: 16px;
  position: relative;
  box-sizing: border-box;

  .slick-slider {
    padding: 0 36px;
    
    @media (max-width: 1024px) {
      padding: 0 32px;
    }
  }

  .slick-arrow.slick-disabled {
    display: inline-flex !important;
    opacity: 0.45;
    cursor: default;
    background: #f8fafc !important;
    border-color: #e2e8f0 !important;
    
    svg {
      color: #94a3b8 !important;
    }
  } 
  .slick-list{
    border-bottom: 1px solid #e6e8f1;
    overflow: hidden;
  }
  .slick-track {
    display: flex !important;
    justify-content: flex-start;
    min-height: 38px;
    margin: 0;
    align-items: center;
  }
  .slick-slide {
    margin-right: 18px;
    min-height: 100%;
    max-height: 100%;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    
    @media (max-width: 1024px) {
      margin-right: 14px;
    }
    
    @media ${themeSizes.tablet} {
      margin-right: 0 !important;
      justify-content: center !important;
      text-align: center !important;
    }
    
    @media ${themeSizes.mobile} {
      flex-direction: row !important;
      justify-content: center !important;
    };
    > div {
      display: flex !important;
      outline: none;
      height: 100%;
      align-items: center;
      justify-content: center !important;
      width: 100% !important;
      @media ${themeSizes.mobile} {
        height: auto;
        justify-content: center !important;
      };
    }
    span {
      min-width: auto;
      max-width: 100%;
      display: inline-flex;
      align-items: center;
      padding-bottom: 0;
      white-space: nowrap;
      text-align: center;
    }
  }
`;
export const VerticalEKYCNav = styled.div`
  width: 100%;
  margin-top: 20px;
  position: relative;
  background-color:white;
  .slick-arrow.slick-disabled {
    display: none !important;
  } 
  .slick-list{
    border-bottom: 1px solid #e6e8f1;
  }
  .slick-track {
    display: flex !important;
    min-height: 34px;
    margin: 0;
  }
  .slick-slide {
    margin-right: 22px;
    min-height: 100%;
    max-height: 100%;
    @media ${themeSizes.tablet} {
      width:200px !important;
    };
    @media ${themeSizes.mobile} {
      width:100% !important;
      background-color:white;
      // border: 2px solid #dfdfdf;
      // border-radius: 5px;
      margin-left:0px;
      // margin-right:10px;
      border-bottom: 0px !important;
     
    };
    div {
      display: inline-flex !important;
      outline: none;
      height: 100%;
      @media ${themeSizes.tablet} {
        width:150px !important;
        justify-content:center;
      };
      @media ${themeSizes.mobile} {
        width:100% !important;
        height: 45px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction: row !important;
      
      };
      span {
        min-width: auto;
        max-width: 100%;
        /* use when tick mark enable
        max-width: 84%;
         */
        display: inline-block;
        padding-bottom: 13px;
      }
    }
  }
`;
export const LeftSideNavs = styled.ul`
  padding: 0px;
  position: sticky;
  top: 64px;
  align-self: flex-start;
  z-index: 100;
  flex-shrink: 0;
  li {
    list-style: none;
    height: 72px;
    display: flex;
    align-items: center;
    padding-left: 28px;
    font-weight: ${semiBold};
    ${baseCaption}
    cursor:pointer;
    svg {
      vertical-align: middle;
      margin-right: 18px;
    }
    &.active {
      background: ${white};
      color: ${blue300};
      font-weight: ${bold};
    }
  }

  @media ${themeSizes.tablet} {
    position: static;
    top: auto;
    display: flex;
    flex-direction: row;
    width: 100%;
    background: ${white};
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 16px !important;
    
    li {
      flex: 1;
      height: 56px;
      justify-content: center;
      padding-left: 0;
      border-bottom: 3px solid transparent;
      transition: all 0.2s ease-in-out;
      
      svg {
        margin-right: 0;
      }
      
      &.active {
        border-bottom: 3px solid ${blue300};
        background: transparent;
      }
    }
  }
`;

export const RightSideContent = styled.div`
  background: ${white};
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  min-height: 500px;
  padding-left: 24px;
  padding-right: 24px;
  overflow-x: hidden;
  background-color: ${props => props.bgColor || 'white'};

  @media ${themeSizes.tablet} {
    padding-left: 12px;
    padding-right: 12px;
    width: 100% !important;
    max-width: 100% !important;
  }

  @media ${themeSizes.mobile} {
    padding-left: 8px;
    padding-right: 8px;
    width: 100% !important;
    max-width: 100% !important;
  }
  & > div {
    ${(props) =>
    props.contentMargin &&
    css`
        margin: ${props.contentMargin};
        padding-right: 24px;
      `}
  }
  ${props => props.splitColumn && css`
    display:flex;
    justify-content:space-between;
    padding-right: 24px;
      > section:first-child{
            width:65%
      }

     
      ${VerticalNav}{
        width:100%;
      }
  `}
`;
export const Title = styled.p`
    margin:0px;
    height: 72px;
    ${microHeading.regular}
    font-weight: ${(props) => props.titleFontWeight || semiBold};
    display: flex;
    align-items: center;
    color:${(props) => props.titleColor || "#000000"};
`;

export const VerticalNavItem = styled.div`
  padding: 8px 16px;
  color: ${black700};
  ${baseCaption}
  font-weight: ${semiBold};
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  position: relative;
  white-space: nowrap;
  user-select: none;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  width: fit-content !important;
  max-width: fit-content !important;
  margin: 0 auto !important;

  &:hover:not(.active) {
    color: ${blue300};
    background: #f8fafc;
  }

  &.active {
    color: ${blue300};
    font-weight: ${bold};
    span {
      color: ${blue300};
      font-weight: ${bold};
    }
    &:after {
      content: '';
      position: absolute;
      display: block;
      height: 3px;
      border-radius: 3px 3px 0 0;
      background: ${blue300};
      bottom: -1px;
      left: 0;
      width: 100%;
      z-index: 2;
    }
  }
  
  @media (max-width: 1024px) {
    height: 36px;
    font-size: 13px;
    padding: 6px 14px;
  }

  @media (max-width: 768px) {
    height: 34px;
    font-size: 12px;
    padding: 6px 12px;
    width: fit-content !important;
    max-width: fit-content !important;
    margin: 0 auto !important;
    justify-content: center !important;
    text-align: center !important;
  }
/* tick mark css */
& > i {
  content: '';
  color: ${white};
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border-radius: 50%;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  transform: translateY(-1.5px);
  background: ${green300};
  border: 1px solid transparent;
  flex-shrink: 0;
  :before {
    content: '';
    position: relative;
    bottom: 1px;
    width: 3.5px;
    border-bottom: 1.5px solid ${white};
    height: 7px;
    border-right: 1.5px solid ${white};
    transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}  
`;
export const VerticalEkycNavItem = styled.div`
    padding:0;
    margin:0;
    width:auto;
    color: ${black700};
    ${baseCaption}
    font-weight: ${semiBold};
    cursor:pointer;
      height: 31px;
      display: inline-flex;
      align-items: flex-start;
      position: relative;
      @media ${themeSizes.mobile} {
        background-color:white !important;
        width:400px !important;
        display:flex;
        justify-content:center;
        
       
      };
      &.active{
          :after{
          content:'';
          position:absolute;
          display:inline-block;
          height:2px;
          border-radius:3px;
          background: ${blue300};
          bottom:0;
          top:100%;
          left:0;
          width:100%;
      }
      }
      /* tick mark css */
     & > i{
      content:'';
      color: ${white};
      width: 16px;
      height: 16px;
      border-radius: 16px;
      margin-top: 3px;
      display: inline-flex;
      align-items: center;
      justify-content: space-around;
      text-align:center;
      vertical-align: top;
      position: relative;
      right:0px;
      margin-left:10px;
      background: ${green300};
      border:1px solid transparent;
          :before{
              content:''; 
              position: relative;
              bottom:1px;
              width: 4px;
              border-bottom: 1px solid ${white};
             
              height: 10px;
              border-right: 1px solid ${white};
             
              transform: rotate(45deg);
              -o-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              -webkit-transform: rotate(45deg);
                                  
          }
  }  
`;
const ArrowBackground = styled.span`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
  svg {
    font-size: 11px;
    color: #475569;
  }
  
  &:hover:not(.slick-disabled) {
    background: #f1f5f9;
    border-color: #cbd5e1;
    svg {
      color: #1e293b;
    }
  }

  &.slick-disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: #f8fafc !important;
    border-color: #e2e8f0 !important;
    pointer-events: none;
    svg {
      color: #94a3b8 !important;
    }
  }
  
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 888;
`;

const ArrowEKYCBackground = styled.span`
  background: #000;
  border: 1px solid #000;
  border-radius: 50%; 
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top:10px;
  margin-left: 25px;
  svg {
    font-size: 10px;
  }
  position: absolute;
  top: 0;
 
`;
export const PrevArrow = styled(ArrowBackground)`
  left: 4px;
`;
export const NextArrow = styled(ArrowBackground)`
  right: 4px;
`;
export const PreEKYCArrow = styled(ArrowEKYCBackground)`
  left: -30px;
`;
export const NextEKYCArrow = styled(ArrowEKYCBackground)`
  right: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  padding-right: 16px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 20px;
    padding-right: 0;
  }

  > div:first-child {
    flex: 1;
    min-width: 0;
    width: 100%;
    >p {
      margin: 18px;
      text-align: center;
    }
  }

  > div:last-child {
    flex-shrink: 0;
    max-width: 100%;
    @media (max-width: 1200px) {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

